// extracted by mini-css-extract-plugin
export default {"searchWordHighlight":"style__searchWordHighlight___206kH"};